import { IPaginationParam, IPaginationResult } from 'lib/ajax-helper';
import { useQuery, UseQueryOptions } from 'react-query';
import { getAdminOrder, indexOrders } from 'services/api-orders.service';
import {
  getTransaction,
  indexTransactions,
} from 'services/api-payments.service';
import {
  IAdminOrder,
  IFuelOrdersFilter,
  IOrder,
} from 'shared/interfaces/orders.interface';
import {
  IndexPaymentsTransactionData,
  IndexPaymentsTransactionFilter,
  PaymentTransaction,
} from 'shared/interfaces/payments.interface';

export const queryKeys = {
  adminOrder: 'adminOrder',
  indexOrders: 'indexOrders',
  indexPaymentTransactions: 'indexPaymentTransactions',
  paymentTransactionDetails: 'paymentTransactionDetails',
};

export const useAdminOrder = (
  orderId: string,
  options?: UseQueryOptions<IAdminOrder>
) => {
  return useQuery(
    [queryKeys.adminOrder, orderId],
    () => getAdminOrder(orderId),
    options
  );
};

export const useIndexOrders = (
  pagination: IPaginationParam,
  filters: IFuelOrdersFilter,
  options?: UseQueryOptions<IPaginationResult<IOrder>>
) => {
  return useQuery(
    [queryKeys.indexOrders, pagination, filters],
    () => indexOrders(pagination, filters),
    options
  );
};

export const usePaymentTransactions = (
  params: Partial<IndexPaymentsTransactionFilter & IPaginationParam>,
  options?: UseQueryOptions<IndexPaymentsTransactionData>
) => {
  return useQuery(
    [queryKeys.indexPaymentTransactions, params],
    () => indexTransactions(params),
    { ...options }
  );
};

export const usePaymentTransactionDetails = (
  trxId: string,
  options: UseQueryOptions<PaymentTransaction>
) =>
  useQuery(
    [queryKeys.paymentTransactionDetails, trxId],
    () => getTransaction(trxId),
    { ...options }
  );
